import '../operation-hours/style.scss';

import { FormikErrors, FormikTouched } from 'formik';
import React, { useState } from 'react';
import { Col, Row, Tab, Tabs } from 'react-bootstrap-v5';
import { useTranslation } from 'react-i18next';

import { TimeInWeek } from '../../../../models';
import { OperationHoursAndMap } from '../../../../models/OperationHoursAndMap';
import ManagementTimeInWeek from '../../component/management-time-in-week/ManagementTime';


/**
 * Generic Props — có thể dùng cho mọi Formik model miễn là model có:
 *  regularHours: TimeInWeek[]
 *  ramadanHours: TimeInWeek[]
 */
interface RequireOperationHours {
  regularHours?: TimeInWeek[];
  ramadanHours?: TimeInWeek[];
}

interface TechOperationHoursProps<T extends RequireOperationHours> {
  rtl: boolean;
  values: T;
  errors: FormikErrors<T>;
  touched: FormikTouched<T>;
  operationHoursAndMap: OperationHoursAndMap[];
  setFieldValue: (field: keyof T, value: any, shouldValidate?: boolean) => void;
  setTouched: (value: FormikTouched<T>, shouldValidate?: boolean) => void;

  step?: number;
  currentCheckCustomStep?: number;
  className?: string;
  mode?: string
  overnightCfg?: {
    endTime: number
    isActive: boolean
  }
}

function TechOperationHours<T extends RequireOperationHours>({
  rtl,
  values,
  errors,
  operationHoursAndMap,
  setFieldValue,
  mode,
  overnightCfg
}: TechOperationHoursProps<T>) {
  console.log("values", values);
  const { t } = useTranslation();
  const [tabSelected, setTabSelected] = useState("regular");

  const onUpdateValueRegularHours = (data: TimeInWeek[]) => {
    const cloned = JSON.parse(JSON.stringify(data));
    setFieldValue("regularHours", cloned);
  };

  const onUpdateValueRamadanHours = (data: TimeInWeek[]) => {
    const cloned = JSON.parse(JSON.stringify(data));
    setFieldValue("ramadanHours", cloned);
  };

  return (
    <div className="box-step-2">
      <h3 className="mt-5 mb-5">
        {t("USERS_PAGE.CONTENT_STEP.STEP4.TITLE_TECH_OPERATION_HOURS")}
      </h3>

      {errors.regularHours && (
        <div className="small text-danger">{errors.regularHours as any}</div>
      )}

      <Row>
        <Col sm={12} className="manage-hours">
          <Tabs
            defaultActiveKey={tabSelected}
            className="mb-5"
            onSelect={(key) => setTabSelected(key ?? "regular")}
          >
            <Tab eventKey="regular" title={t("USERS_PAGE.STEP_UPDATE_USER.REGULAR_HOURS")}>
              <ManagementTimeInWeek
                timeInWeek={values.regularHours || []}
                isRamadan={false}
                rtl={rtl}
                operationHoursAndMap={operationHoursAndMap}
                updateValueOperationHours={onUpdateValueRegularHours}
                mode={mode}
                overnightCfg={overnightCfg}
              />
            </Tab>

            <Tab eventKey="ramadan" title={t("USERS_PAGE.STEP_UPDATE_USER.RAMADAN_HOURS")}>
              <ManagementTimeInWeek
                timeInWeek={values.ramadanHours || []}
                isRamadan={true}
                rtl={rtl}
                operationHoursAndMap={operationHoursAndMap}
                updateValueOperationHours={onUpdateValueRamadanHours}
                mode= {mode}
                overnightCfg={overnightCfg}
              />
            </Tab>
          </Tabs>
        </Col>
      </Row>
    </div>
  );
}

export default TechOperationHours;
